export default __webpack_public_path__ + "static/1182-406574cd29f11982c3623899e8b10e61.gif";